module.exports = __webpack_public_path__ + "static/media/Badge_PlaiesCicatrisation.ddb25ecc.png";